import React from 'react';
import { config } from '@triare/auth-redux';

import Layout from '../../../components/Layout';
import ArticlesView from '../../../components/Pages/TippingArticles/View';

const { displayName } = config;

export default function TippingArticlesView(): React.ReactNode | null {
  document.title = `${displayName}: Tipping Articles`;

  return (
    <Layout>
      <ArticlesView />
    </Layout>
  );
}
